import React, { Component } from 'react';
import { func, object, shape, string } from 'prop-types';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import { ValidationError } from '../../components';

import css from './FieldNumberInputWithoutNegative.module.css';

const FieldNumberInputWithoutNegativeComponent = props => {
  const {
    rootClassName,
    className,
    inputRootClass,
    customErrorText,
    id,
    label,
    labelClassName,
    input,
    meta,
    inputRef,
    hideErrorMessage,
    displayColumn,
    errorClassName,
    mobileLabelBottom,
    withPercent,
    ...rest
  } = props;

  if (label && !id) {
    throw new Error('id required when a label is given');
  }

  const { valid, invalid, touched, error } = meta;
  const errorText = customErrorText || error;
  const hasError = touched && invalid && errorText;

  const [isFocused, setIsFocused] = React.useState(false);

  const handleChange = e => {
    let value = e.target.value
      .replace(',', '.')
      .replace(/[^0-9.]/g, '')
      .replace(/(\..*)\./g, '$1');

    const match = value.match(/^(\d+(\.\d{0,2})?)?/);
    value = match ? match[0] : '';

    input.onChange(value);
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = e => {
    setIsFocused(false);
    input.onBlur?.(e);
  };

  const displayValue = !withPercent
    ? input.value
    : isFocused
    ? input.value
    : input.value
    ? `${input.value}%`
    : '';

  const inputClasses = classNames(css.input, {
    [css.inputSuccess]: valid,
    [css.inputError]: hasError,
  });

  const inputProps = {
    className: inputRootClass || inputClasses,
    id,
    type: 'text',
    inputMode: 'numeric',
    value: displayValue,
    onChange: handleChange,
    onFocus: handleFocus,
    onBlur: handleBlur, // теперь всегда вызывается
    ref: inputRef,
    ...rest,
  };

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      {label && (
        <label className={labelClassName} htmlFor={id}>
          {label}
        </label>
      )}
      <div
        style={
          displayColumn
            ? {
                display: 'flex',
                flexDirection: 'column',
                alignItems: mobileLabelBottom ? 'center' : '',
              }
            : { display: 'flex', flexDirection: 'row', marginTop: '16px' }
        }
      >
        <input {...inputProps} />
        {mobileLabelBottom}
        {!hideErrorMessage && hasError && (
          <ValidationError className={errorClassName} fieldMeta={{ touched, error: errorText }} />
        )}
      </div>
    </div>
  );
};

FieldNumberInputWithoutNegativeComponent.defaultProps = {
  rootClassName: null,
  className: null,
  inputRootClass: null,
  customErrorText: null,
  id: null,
  label: null,
  inputRef: null,
  hideErrorMessage: false,
};

FieldNumberInputWithoutNegativeComponent.propTypes = {
  rootClassName: string,
  className: string,
  inputRootClass: string,
  customErrorText: string,
  id: string,
  label: string,
  input: shape({
    onChange: func.isRequired,
    value: string,
  }).isRequired,
  meta: object.isRequired,
};

class FieldNumberInputWithoutNegative extends Component {
  render() {
    return <Field component={FieldNumberInputWithoutNegativeComponent} {...this.props} />;
  }
}

export default FieldNumberInputWithoutNegative;
